import BaseAppender from '@mcom/log4ts/build/appenders/BaseAppender';
import { IAppender } from '@mcom/log4ts/build/IAppender';
import { LogEntry } from '@mcom/log4ts/build/LogEntry';
import { AppAnalytics } from '../shared/analytics';
import { LogLevel } from '@mcom/log4ts/build/LogLevel';

export class AnalyticsAppender extends BaseAppender implements IAppender {
  // Application Insights severity level; unhandled crashes are reported as exceptions instead.
  private static readonly SEVERITY: { [level: number]: number } = {
    [LogLevel.FATAL]: 4,
    [LogLevel.ERROR]: 3,
    [LogLevel.WARN]: 2,
    [LogLevel.INFO]: 1
  };

  append(entry: LogEntry) {
    const severity = AnalyticsAppender.SEVERITY[entry?.level];

    if (severity === undefined) {
      AppAnalytics.event('log', JSON.parse(JSON.stringify(entry)));
      return;
    }

    AppAnalytics.trace(entry.message, severity, JSON.parse(JSON.stringify(this.tryStripHtml(entry))));
  }

  clear() {
    //do nothing
  }

  private tryStripHtml(entry: LogEntry): LogEntry {
    try {
      if (entry.message?.includes('<!DOCTYPE html>')) {
        // too long message becasue of base64 encoded background image (log text is throttled and valuable information lost if unmanaged)
        const start = entry.message.indexOf('<!DOCTYPE html>');
        const end = entry.message.indexOf('</html>', start);
        const html = entry.message.substring(start, end + 8);
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(html, 'text/html');
        const styleElements = htmlDoc.body.getElementsByTagName('style');
        if (styleElements.length) {
          htmlDoc.body.removeChild(styleElements[0]);
        }
        htmlDoc.body.removeAttribute('style');
        entry.message = entry.message.replace(html, htmlDoc.body.outerHTML);
      }
    } catch {}
    return entry;
  }
}
